export default "__VITE_ASSET__ad660323__"